<div class="row">
  <div class="col-xs-12 data">
    <div class="row">
      <div class="col-md-4 col-lg-2">Nome:</div>
      <div class="col-md-8 col-lg-10">
        {{ type === 'Consulta' ? getPrefix(person) + (person?.name || 'Undefined') : person?.name || 'Undefined' }}
      </div>
    </div>
    <div class="row" *ngIf="type == 'Person'">
      <div class="col-md-4 col-lg-2">Data de nascimento:</div>
      <div class="col-md-8 col-lg-10">{{ person?.birthDate | mask : '00/00/0000' }}</div>
    </div>
    <div class="row" *ngIf="type == 'Person'">
      <div class="col-md-4 col-lg-2">CPF:</div>
      <div class="col-md-8 col-lg-10">{{ identifier.CPF ?? person?.cpf | mask : '000.000.000-00' }}</div>
    </div>
    <div class="row" *ngIf="type !== 'Consulta'">
      <div class="col-md-4 col-lg-2">Genêro:</div>
      <div class="col-md-8 col-lg-10">{{ person?.gender | translateGender }}</div>
    </div>
    <div class="row" *ngIf="type == 'Consulta'">
      <div class="col-md-4 col-lg-2">Especialidade:</div>
      <div class="col-md-8 col-lg-10">{{ person?.qualification[0]?.identifier[0]?.value }}</div>
    </div>
    <div class="row">
      <div class="col-md-4 col-lg-2">Telefone para contato:</div>
      <div class="col-md-8 col-lg-10">{{ (person?.mobile ? person.mobile : telecom.phone) | mask : '(00) 00000-0000' }}</div>
    </div>
  </div>
</div>
